import { FormattedMessage } from 'react-intl';

import AnalyticsEvents from '@/analytics/AnalyticsEvents';
import { isWorkshopParentFrontend } from '@/config';
import { EXPAND_WARNINGS, sendMessage } from '../app/MessageHandler';

const Footer = ({ disabled }: { disabled: boolean }) => {
    const handleSeeActiveWarnings = () => {
        if (isWorkshopParentFrontend()) {
            AnalyticsEvents.viewAllRepairWearTearRepairWarnings();
        } else {
            AnalyticsEvents.viewAllRepairVehicleDiagnostic();
        }
        sendMessage({ type: EXPAND_WARNINGS, payload: null });
    };

    return (
        <div className="padding-y-15 bg-white border rounded-bottom">
            <div className="display-flex justify-content-center">
                {disabled ? (
                    <span className="text-color-primary text-size-14 opacity-40">
                        <FormattedMessage id="intl-msg:vehicle-warnings.seeActiveWarnings" />
                    </span>
                ) : (
                    <a
                        role="button"
                        tabIndex={0}
                        className="text-color-primary text-size-14 cursor-pointer"
                        onClick={handleSeeActiveWarnings}
                    >
                        <FormattedMessage id="intl-msg:vehicle-warnings.seeActiveWarnings" />
                    </a>
                )}
            </div>
        </div>
    );
};

export default Footer;
